import { HttpRequest } from "./http.js";
import { HttpRequest2 } from "./http2.js";
import md5 from "js-md5";
import QueryString from "querystring";
import axios_new from "axios";
// import qs from 'qs';

// const temp1 = "-dhf"
const temp = "";
// const temp1 = "";
const temp1 = "-tang";
const Connection = process.env.URL_CONNECTION;
const Connection2 = process.env.URL_CONNECTION_2;
const API_PATH = process.env.API_PATH;
console.log(API_PATH, "API_PATHAPI_PATH");
const API_PATHOBJ = {
  api_model_only: `${API_PATH.api_model_only}${temp}`,
  api_model_system: `${API_PATH.api_model_system}${temp}`,
  api_model_school: `${API_PATH.api_model_school}${temp}`,
  api_model_trip: `${API_PATH.api_model_trip}${temp}`,
  api_model_resource: `${API_PATH.api_model_resource}${temp}`,
  api_model_auth: `${API_PATH.api_model_auth}${temp}`,
  api_model_desk: `${API_PATH.api_model_desk}${temp}`,
  api_model_user: `${API_PATH.api_model_user}${temp}`,
  api_model_course: `${API_PATH.api_model_course}${temp}`,
  api_model_recruitment: `${API_PATH.api_model_recruitment}${temp}`,
  api_model_platform: `${API_PATH.api_model_platform}${temp}`,
  api_model_attendance: `${API_PATH.api_model_attendance}${temp}`,
  api_model_user: `${API_PATH.api_model_user}${temp}`
};

let http = {
  //退出登录
  logOut: function () {
    return HttpRequest.getRequest({
      method: "GET",
      url: Connection + "/wenbo-" + API_PATHOBJ.api_model_auth + "/oauth/logout"
    });
  },

  //修改密码
  updatePassword: function (oldPasswd, newPasswd, newPasswdAgain) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_user +
        "/update-password?oldPassword=" +
        md5(oldPasswd) +
        "&newPassword=" +
        md5(newPasswd) +
        "&newPassword1=" +
        md5(newPasswdAgain),
      // data: params,
      header: {
        "content-type": "application/x-www-form-urlencoded"
      }
    });
  },

  menuRoutes: function (params) {
    return HttpRequest.getRequest({
      method: "get",
      url:
        Connection + "/wenbo-" + API_PATHOBJ.api_model_system + "/menu/routes",
      data: params
    });
  },

  //学段列表
  getPeriodListInfo11: function () {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/studyperiod/periodPage",
      // data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //创建学段信息
  createPeriodInfos: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/studyperiod/periodSave",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //获取指定市的区域列表数据
  getRegionListByCity: function (datas) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_system +
        "/region/lazy-tree",
      data: datas,
      header: {
        "content-type": "application/x-www-form-urlencoded;charset=UTF-8"
      }
    });
  },

  //创建学校账号
  createSchoolInfo: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/school/saveSchool",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //编辑学校账号
  updateSchoolBaseInfo: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/school/update",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //获取学校账号信息
  getSchoolAccountListByCity: function (datas) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/school/pageSchool",
      data: datas,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //删除学校账号信息
  removeSchoolInfo: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/school/remove?ids=" +
        params,
      // data: params,
      header: {
        "content-type": "application/x-www-form-urlencoded;charset=UTF-8"
      }
    });
  },

  //疫情功能
  //今日上报人数比例
  getEducationBureauGraphicalReport: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/epidemicSituationEdu/educationBureauGraphicalReport?time=" +
        params
    });
  },

  //今日体温统计
  getEducationBureauBodyTemperature: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/epidemicSituationEdu/educationBureauBodyTemperature?time=" +
        params
    });
  },

  //同居人核酸结果阳性数量
  getCohabitant: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/epidemicSituationEdu/cohabitant?time=" +
        params
    });
  },

  //14天是否市外居住史人数统计
  getSuburbs: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/epidemicSituationEdu/suburbs?time=" +
        params
    });
  },

  //新增阳性病例统计曲线图
  getPositiveStatistics: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/epidemicSituationEdu/positiveStatistics",
      data: params
    });
  },

  //今日学校疫情未上报人数比例排名
  getUnreportedSchoolRankings: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/epidemicSituationEdu/unreportedSchoolRankings?time=" +
        params
    });
  },

  //今日疫情上报学校已完成与未完成学校比例
  getCompletedAndUnfinished: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/epidemicSituationEdu/completedAndUnfinished?time=" +
        params
    });
  },

  //今日市各地区学校上报完成度
  getDistrictSchoolsReport: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/epidemicSituationEdu/districtSchoolsReport?time=" +
        params
    });
  },

  // GET请求 获取三亚市所有区列表
  getCityregionList: function (datas) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/epidemicSituationEdu/areaList",
      data: datas
    });
  },

  //获取某区所有学校列表
  areaEpidemicSituationList: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/epidemicSituationEdu/areaEpidemicSituationList",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  // GET请求 获取某学校所有年级列表
  schoolGradeList: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/epidemicsituation/gradeListEdu?schoolId=" +
        params
    });
  },

  // 获取某班级所有疫情防控学生列表-分页
  studentEpidemicSituationList: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/epidemicSituationEdu/studentEpidemicSituationList",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  // GET请求 获取某年级所有班级列表
  gradeClassList: function (datas) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/epidemicsituation/classList",
      data: datas
    });
  },

  // GET请求 疫情id获取疫情防控详情
  byIdEpidemicSituation: function (datas) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/epidemicSituationEdu/detailEdu",
      data: datas
    });
  },

  //批量(或单个)删除疫情防控学生信息
  deleteEpidemicSituationList: function (datas) {
    return HttpRequest.getRequest({
      method: "DELETE",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/epidemicsituation/remove?ids=" +
        datas
    });
  },

  //获取省市列表
  getProvincesCitiesList: function () {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/epidemicsituation/getProvinceCity"
    });
  },

  //上报统计列表
  pageWeatherReportList: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/epidemicsituation/whetherReportEdu",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //上报记录
  pageReportRecordList: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/epidemicsituation/reportRecord",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  getCourseTime: function (datas) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection + "/wenbo-" + API_PATHOBJ.api_model_trip + "/getCourseTime",
      data: datas
    });
  },
  createCourseTime: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_trip +
        "/createCourseTime",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },
  delCourseTime: function (params) {
    return HttpRequest.getRequest({
      method: "DELETE",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_trip +
        "/delCourseTime?id=" +
        params
    });
  },

  createTrip: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url: Connection + "/wenbo-" + API_PATHOBJ.api_model_trip + "/createTrip",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },
  getCourseTableEveryWeek: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_trip +
        "/getCourseTableEveryWeek",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },
  queryTrip: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url: Connection + "/wenbo-" + API_PATHOBJ.api_model_trip + "/queryTrip",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },
  semestersList: function (params) {
    return HttpRequest.getRequest({
      method: "get",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/resource/semestersList",
      data: params
    });
  },
  getSchoolResourceFilePage: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/resource/resourcePage",
      header: {
        "content-type": "application/json;charset=UTF-8"
      },
      data: params
    });
  },

  getCommonResourceFilePage: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/resource/resourcePublicPage",
      header: {
        "content-type": "application/json;charset=UTF-8"
      },
      data: params
    });
  },

  // 学校-年级-班级id 获取教师列表
  lessonPreparationTeacher: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/lessonpreparation/lessonPreparationTeacher",
      header: {
        "content-type": "application/json"
      },
      data: params
    });
  },

  orgCityList: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_course +
        "/preparation/orgCityList",
      data: params
    });
  },

  updateTripDetails: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_trip +
        "/updateTripDetails",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },
  queryTripDetails: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_trip +
        "/queryTripDetails",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },
  getSchoolResourceSubjectTree: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_resource +
        "/getSchoolResourceSubjectTree",
      data: params
    });
  },

  getSchoolResourceSubject: function () {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/lessonpreparation/lessonPreparationPage"
    });
  },

  approvedList: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_resource +
        "/approvedList",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },
  getSchoolResourceSubjectList: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_resource +
        "/getSchoolResourceSubjectList",
      data: params
    });
  },
  uploadFile: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url: Connection + "/wenbo-" + API_PATHOBJ.api_model_poi + "/uploadFile",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  createSchoolResource: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_resource +
        "/createSchoolResource",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  resourcedictree: function (params) {
    var data = QueryString.stringify(params);
    return HttpRequest.getRequest({
      method: "get",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_system +
        "/dict/child-list?" +
        data
    });
  },

  resourcedictree2: function (params) {
    var data = QueryString.stringify(params);
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_system +
        "/dict/dictionary2?" +
        data
    });
  },

  resourceRelateYear: function () {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/resource/documentYear"
    });
  },

  getSchoolResourceFileInfo: function (params) {
    var data = QueryString.stringify(params);
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/resource/resourceDetails?" +
        data
    });
  },

  //公共资源-根据学段查询年级信息
  queryGradeInfosByStudyPeriod: function (params) {
    var data = QueryString.stringify(params);
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/epidemicsituation/gradeListEdu?" +
        data
    });
  },

  addComments: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url: "/wenbo/wenbo-" + API_PATHOBJ.api_model_resource + "/addComments",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  invitePage: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/lessonpreparation/lessonPreparationInvite",
      header: { "content-type": "application/x-www-form-urlencoded" }
    });
  },

  courseApply: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/lessonpreparation/lessonPreparationDecide",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  coursePage: function (params) {
    var data = QueryString.stringify(params);
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/lessonpreparation/lessonPreparationPage?" +
        data
    });
  },

  courseFavorite: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_course +
        "/favorite/modify",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },
  courseDetail: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_course +
        "/preparation/detail",
      data: params
    });
  },

  lessonPreparationDetails: function (params) {
    var data = QueryString.stringify(params);
    data = data == "" ? "" : "?" + data;
    return HttpRequest.getRequest({
      method: "get",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/lessonpreparation/lessonPreparationDetails" +
        data,
      header: {
        "content-type": "application/x-www-form-urlencoded"
      }
    });
  },

  orgSchoolList: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_course +
        "/preparation/orgSchoolList",
      data: params
    });
  },
  gradeList: function (params) {
    return HttpRequest.getRequest({
      method: "get",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/resource/gradeList?ids=" +
        params.ids
      // data: params
    });
  },

  // 该位置的接口仅提供给公共资源 上传对话框 根据学段选择年级
  gradeListInCommonResource: function (params) {
    return HttpRequest.getRequest({
      method: "get",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/resource/getAllSchoolResourceGradeTree?resourceSubjectParent=" +
        params.ids
    });
  },

  // 资源收藏
  getResourceCollection: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_resource +
        "/resourceCollection",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  // 获取学校列表
  pageSchoolList: function () {
    return HttpRequest.getRequest({
      method: "get",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/lessonpreparation/pageSchool",
      header: {
        "content-type": "application/x-www-form-urlencoded"
      }
    });
  },

  resourceCollect: function (params) {
    var data = QueryString.stringify(params);
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/resource/resourceCollect?" +
        data,
      header: {
        "content-type": "application/x-www-form-urlencoded"
      }
    });
  },

  commentsList: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_resource +
        "/commentsList",
      data: params
    });
  },

  deleteSchoolResource: function (params) {
    return HttpRequest.getRequest({
      method: "DELETE",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_resource +
        "/deleteSchoolResource?fileId=" +
        params
    });
  },

  approved: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection + "/wenbo-" + API_PATHOBJ.api_model_resource + "/approved",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  resourceSave: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/resource/resourceSave",
      data: params
    });
  },

  putFile: function (params, progressCallback) {
    return HttpRequest.getRequest({
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_resource +
        "/oss/endpoint/put-file?code=ftposs",
      method: "POST",
      data: params,
      onUploadProgress: progressEvent => {
        var progress =
          ((progressEvent.loaded / progressEvent.total) * 100).toFixed(0) || 0;
        progressCallback(progress);
      }
    });
  },

  putFileWithoutProgress: function (params) {
    return HttpRequest.getRequest({
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_resource +
        "/oss/endpoint/put-file?code=ftposs",
      method: "POST",
      data: params
    });
  },

  // 集体备课 上传备课ppt资源 单独使用
  putPptFileWithoutProgressLocal: function (params) {
    return HttpRequest.getRequest({
      url: "/office" + "/only/upload",
      // url: Connection + "/wenbo-" + API_PATHOBJ.api_model_only + "/only/upload",
      method: "POST",
      data: params,
      header: {
        "content-type": "multipart/form-data"
      }
    });
  },

  // 集体备课 上传备课ppt资源 单独使用 online
  putPptFileWithoutProgress: function (params) {
    return HttpRequest.getRequest({
      url: Connection2 + "/only/upload",
      method: "POST",
      data: params,
      header: {
        "content-type": "multipart/form-data"
      }
    });
  },

  sujectList: function (params) {
    var data = QueryString.stringify(params);
    return HttpRequest.getRequest({
      method: "get",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/resource/sujectList?" +
        data
    });
  },

  clazzList: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_course +
        "/preparation/clazzList",
      data: params
    });
  },

  teacherList: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_course +
        "/preparation/teacherList",
      data: params
    });
  },

  documenttemplateRemove: function (params) {
    var data = QueryString.stringify(params);
    data = data == "" ? "" : "?" + data;
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/documenttemplate/remove" +
        data,
      header: {
        "content-type": "application/json"
      }
    });
  },

  documenttemplateList: function () {
    return HttpRequest.getRequest({
      method: "get",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/documenttemplate/listTemplate",
      header: {
        "content-type": "application/json"
      }
    });
  },

  preparationAdd: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_course +
        "/preparation/add",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  examGet: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_course +
        "/exam/score/page",
      data: params
    });
  },
  getGradeByExam: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_course +
        "/exam/getGradeByExam",
      data: params
    });
  },
  getSubjectsByClazz: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_course +
        "/exam/getSubjectsByClazz",
      data: params
    });
  },
  getGradeByOrgId: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_course +
        "/exam/getGradeByOrgId",
      data: params
    });
  },
  getClazzByGrade: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_course +
        "/exam/getClazzByGrade",
      data: params
    });
  },
  getSubjectByGrade: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_course +
        "/exam/getSubjectByGrade",
      data: params
    });
  },

  //获取学生列表-2.0
  studentList: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_resource +
        "/getStudentList",
      data: params
    });
  },

  //获取德育评价标签树
  getMoralEducationTreeList: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_resource +
        "/getMoralEducationTree",
      data: params
    });
  },

  //添加德育标签
  addEvaluationMarkInfo: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_resource +
        "/createMoralEducationLabel",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //获取当前一级标签分值
  getLabelScoreDetail: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_resource +
        "/getLabelScore",
      data: params
    });
  },

  //教师新增评价学生德育
  addStudentMarkInfo: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_resource +
        "/createMoralEducation",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },
  examGet: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url: Connection + "/wenbo-" + API_PATHOBJ.api_model_course + "/exam/get",
      data: params
    });
  },

  examUpdate: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection + "/wenbo-" + API_PATHOBJ.api_model_course + "/exam/update",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //后台-根据id删除德育评价标签
  deleteMoralEduMark: function (datas) {
    return HttpRequest.getRequest({
      method: "DELETE",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_resource +
        "/delSysMoralEducationByParent?appraiseParent=" +
        datas
    });
  },
  //评价列表标签获取分页
  getStudenLabelScoreList: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_resource +
        "/getLabelScoreList",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  // 获取考试指标列表
  getExamTargetInfo: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_course +
        "/exam/target/list",
      data: params
    });
  },

  //删除考试指标
  deleteTargetMark: function (datas) {
    return HttpRequest.getRequest({
      method: "DELETE",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_course +
        "/exam/target/del?id=" +
        datas
    });
  },

  //添加考试指标
  addTargetInfo: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_course +
        "/exam/target/add",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //获取某班级所有疫情防控学生列表-分页
  getStudenEpidemicSituationList: function (params) {
    var data = QueryString.stringify(params);
    console.log(data, "datadata");
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/epidemicsituation/schoolStudentIllness?",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //获取某学校所有年级列表
  getSchoolGradeList: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/epidemicsituation/gradeList",
      header: {
        "content-type": "application/x-www-form-urlencoded"
      },
      data: params
    });
  },

  getSchoolGradeListByStudyPeriodId: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/epidemicsituation/gradeStudyPeriod?studyPeriodId=" +
        params
    });
  },

  //根据租户id获取某学校所有年级列表-教育端使用
  getSchoolGradeListByTenantId: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/epidemicsituation/gradeListEdu",
      header: {
        "content-type": "application/x-www-form-urlencoded"
      },
      data: params
    });
  },

  //疫情id获取疫情防控详情
  getEpidemicSituationById: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/epidemicSituationEdu/detailEdu",
      data: params
    });
  },

  //导出班级疫情防控Excel
  exportEpidemicSituationList: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_resource +
        "/exportExcel",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //导出班级疫情防控Excel-学校端
  // exportEpidemicSituationListFromSchoolClient: function (params) {
  //   return HttpRequest.getRequest({
  //     method: "POST",
  //     url: Connection + "/wenbo-" + API_PATHOBJ.api_model_school + "/epidemicsituation/exportEpidemicReport",
  //     data: params,
  //     header: {
  //       "content-type": "application/json"
  //     }
  //   });
  // },

  getGradeList: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection + "/wenbo-" + API_PATHOBJ.api_model_school + "/grade/list",
      data: params
    });
  },

  //添加年级
  addGradeInfo: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url: Connection + "/wenbo-" + API_PATHOBJ.api_model_course + "/clazz/add",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //班级分页-回收站
  pageClassInfoByRecycleBin: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/educlass/classPageRecycle",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //删除班级-回收站
  clazzDelByRecycleBin: function (params) {
    return HttpRequest.getRequest({
      method: "DELETE",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/educlass/removeRecycle?ids=" +
        params
    });
  },

  //班级信息-还原-回收站
  clazzInfoByRecyclebin: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/educlass/classRecycleReduction",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //班级分页
  pageClassInfo: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      // url: Connection + "/wenbo-"+api_model_course+"/clazz/page",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/educlass/page",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //删除班级
  clazzDel: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      // url: Connection + "/wenbo-"+api_model_course+"/clazz/del?id=" + params,
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/educlass/remove?ids=" +
        params
    });
  },

  //学级
  addStudentClazz: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/studygrade/pageStudyGrade",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //学级(二)
  addStudentClazzList: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/studygrade/pageStudyGradeList",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //学生分页-回收站
  getStudentListInfoByRecyclebin: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/student/pageStudentRecycle",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //删除学生-回收站
  studentDelByRecyclebin: function (ids) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/student/removeStudentRecycle?ids=" +
        ids,
      header: {
        "content-type": "application/x-www-form-urlencoded"
      }
    });
  },

  //学生资料-还原-回收站
  resetStudentInfoByRecyclebin: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/student/studentRecycleReduction",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //学生分页
  getStudentListInfo: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/student/pageStudent",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //添加学生
  addStudentInfo: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/student/saveStudent",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //删除学生
  studentDel: function (ids) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/student/removeStudent?ids=" +
        ids,
      header: {
        "content-type": "application/x-www-form-urlencoded"
      }
    });
  },

  //上传学生excel资料
  uploadStudentFile: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/student/importBuyerExcelNotice",
      data: params,
      header: {
        "content-type": "multipart/form-data"
      }
    });
  },

  //学校端-图形报表统计
  getGraphicalReport: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_resource +
        "/getEpidemicSituationGraphicalReport",
      data: params
    });
  },

  //添加班级
  addClazzInfo: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      // url: Connection + "/wenbo-"+api_model_course+"/clazz/add",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/educlass/classSave",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //获取班级详情
  getClazzDetail: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_course +
        "/clazz/getInfo",
      data: params
    });
  },

  //修改班级
  updateClazzInfo: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      // url: Connection + "/wenbo-"+api_model_course+"/clazz/upd",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/educlass/update",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //根据条件获取自定义字段列表
  getOtherFields: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_course +
        "/otherFields/getList",
      data: params
    });
  },

  //添加自定义字段
  addOtherFields: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_course +
        "/otherFields/add",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //删除自定义字段
  delOtherFields: function (params) {
    return HttpRequest.getRequest({
      method: "DELETE",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_course +
        "/otherFields/delete?fieldsId=" +
        params
    });
  },

  //根据组织orgid获取学校id
  getSchoolIdByOrgid: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_resource +
        "/getSchoolId",
      data: params
    });
  },

  //教师分页
  pageTeacherInfo: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/teacher/teacherPage",
      data: params,
      header: {
        // "content-type": 'application/json'
        "content-type": "application/x-www-form-urlencoded"
      }
    });
  },

  //添加教师
  addTeacherInfo: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      // url: Connection + "/wenbo-"+api_model_course+"/teacher/add",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/teacher/teacherSave",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },
  //教师信息修改
  updateTeacherInfo: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      // url: Connection + "/wenbo-"+api_model_course+"/teacher/update",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/teacher/teacherUpdate",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //批量删除
  deleteTeacherInfos: function (datas) {
    return HttpRequest.getRequest({
      method: "POST",
      // url: Connection + "/wenbo-"+api_model_course+"/teacher/batchDel?ids=" + datas,
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/teacher/teacherDelete?ids=" +
        datas
    });
  },

  //获取某年级所有班级列表
  getGradeClassList: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/epidemicsituation/classList",
      header: {
        "content-type": "application/x-www-form-urlencoded"
      },
      data: params
    });
  },

  //根据年级id获取某年级所有班级列表
  getGradeClassListBySchoolid: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/epidemicsituation/classListEdu",
      header: {
        "content-type": "application/x-www-form-urlencoded"
      },
      data: params
    });
  },

  //pc
  getGradeClassListPc: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      // url: Connection + "/wenbo-"+API_PATHOBJ.api_model_resource+"/gradeClassListPc",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/educlass/list?gradeId=" +
        params
      // data: params
    });
  },

  getGradeClassListBySchool: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/educlass/gradeIdClassList",
      data: params
    });
  },

  //教师信息excel上传
  uploadTeacherFile: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/teacher/importTeacher",
      data: params,
      header: {
        "content-type": "multipart/form-data"
      }
    });
  },

  //添加学校科目
  addSchoolSubjectInfo: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection + "/wenbo-" + API_PATHOBJ.api_model_course + "/subject/add",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //全校科目列表
  getSchoolSubjectList: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection + "/wenbo-" + API_PATHOBJ.api_model_course + "/subject/list",
      data: params
    });
  },

  // deleteSchoolSubjectInfos: function (params) {
  //     return HttpRequest.getRequest({
  //         // method: "POST",
  //         // url: Connection + "/wenbo-" +
  //         //     API_PATHOBJ.api_model_school +
  //         //     "/subject/remove?ids=" +
  //         //     params

  //         method: "DELETE",
  //         url: Connection + "/wenbo-" +
  //             API_PATHOBJ.api_model_school +
  //             "/subject/remove?ids=" +
  //             params
  //     });
  // },

  //删除全校科目列表数据
  deleteSchoolSubjectInfos: function (params) {
    return HttpRequest.getRequest({
      method: "DELETE",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/subject/schoolSubjectDelete?ids=" +
        params
    });
  },

  //修改学校科目
  updateSchoolSubjectInfo: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection + "/wenbo-" + API_PATHOBJ.api_model_course + "/subject/upd",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //年级科目列表
  getGradeSubjectList: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/subject/listSubject",
      data: params
    });
  },

  //添加任教关系
  addTeacherRelateInfo: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      // url: Connection + "/wenbo-"+api_model_course+"/teacherTeach/add",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/teacherlesson/saveLesson",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //任教关系分页查询
  pageTeacherRelateInfos: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      // url: Connection + "/wenbo-"+api_model_course+"/teacherTeach/page",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/teacherlesson/pageLesson",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //删除任教关系
  deleteTeacherRelate: function (datas) {
    return HttpRequest.getRequest({
      method: "DELETE",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/teacherlesson/removeTeacherbyId?teacherId=" +
        datas
    });
  },
  //删除单独班级科目
  deleteClazzRelate: function (datas) {
    return HttpRequest.getRequest({
      method: "DELETE",
      url:
        "//wenbo-" +
        API_PATHOBJ.api_model_school +
        "/teacherlesson/removeSujectId?classId=" +
        datas
    });
  },

  //教师信息excel上传
  uploadTeacherSubjectInfoFile: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_course +
        "/uploadForTeacherTeach",
      data: params,
      header: {
        "content-type": "multipart/form-data"
      }
    });
  },

  //---文章分组管理
  //顶层分组列表
  getGroupListAll: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_course +
        "/group/listAll",
      data: params
    });
  },

  //文章添加
  addEssay: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url: Connection + "/wenbo-" + API_PATHOBJ.api_model_course + "/essay/add",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //文章分页列表
  essayPage: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection + "/wenbo-" + API_PATHOBJ.api_model_course + "/essay/page",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //文章删除
  deleteEssay: function (datas) {
    return HttpRequest.getRequest({
      method: "DELETE",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_course +
        "/essay/del?id=" +
        datas
    });
  },

  //文章修改
  updEssay: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url: Connection + "/wenbo-" + API_PATHOBJ.api_model_course + "/essay/upd",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //场地分页
  pageSapceList: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      // url: Connection + "/wenbo-"+api_model_course+"/campus/page",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/schoolspace/pageSpace",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //添加场地
  addSapceInfo: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      // url: Connection + "/wenbo-"+api_model_course+"/campus/add",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/schoolspace/save",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //修改场地
  updateSapceInfo: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      // url: Connection + "/wenbo-"+api_model_course+"/campus/upd",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/schoolspace/update",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //删除场地
  deleteSapceInfo: function (datas) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/schoolspace/remove?ids=" +
        datas
    });
  },

  //查看审批申请列表分页
  approvalProcessTypePage: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_resource +
        "/approvalProcessTypePage",
      data: params,
      header: {
        "content-type": "multipart/form-data"
      }
    });
  },

  //查看审批申请列表分页
  approvalDictionaryList: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_resource +
        "/approvalDictionaryList",
      data: params,
      header: {
        "content-type": "multipart/form-data"
      }
    });
  },

  //获取教师列表
  getTeachers: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      // url: Connection + "/wenbo-"+API_PATHOBJ.api_model_resource+"/getTeachers",
      url:
        Connection + "/wenbo-" + API_PATHOBJ.api_model_school + "/teacher/list",
      data: params
    });
  },

  //添加审批类型
  approvalProcessTypeAdd: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_resource +
        "/approvalProcessTypeAdd",
      data: params,
      header: {
        "content-type": "multipart/form-data"
      }
    });
  },

  //添加学期
  addTermInfo: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/semester/saveSemester",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //学期分页
  pageTermListInfo: function (params) {
    // return HttpRequest.getRequest({
    //     method: "GET",
    //     url: Connection + "/wenbo-" + API_PATHOBJ.api_model_school + "/semester/pageSemester"
    // });
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/semester/pageSemester",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //删除学期
  deleteTermInfo: function (datas) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/semester/remove?ids=" +
        datas,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //修改学期
  updateTermInfo: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/semester/updateSemester",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //激活学期
  activeTermInfo: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/semester/activationSemester?ids=" +
        params
    });
  },

  //取消激活学期
  cancleActiveTermInfo: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        // "/b-term/cancelActivationTeam",
        "/semester/cancelSemester",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //学校审批类型删除
  approvalProcessTypeDelete: function (datas) {
    return HttpRequest.getRequest({
      method: "DELETE",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_resource +
        "/approvalProcessTypeDelete?id=" +
        datas
    });
  },

  //后台管理员详细-获取德育评价积极消极标签树
  getLabelTreeInfos: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_resource +
        "/getLabelTree",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //新接口==========================================

  //获取字典值
  getDictionary: function (code) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_system +
        "/dict/dictionary?code=" +
        code
    });
  },
  //获取批量字典值
  getTreeDictionary: function (code) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_system +
        "/dict/dictionary-tree-map?codes=" +
        code
    });
  },

  //课时
  getCourseListInfos: function (params) {
    return HttpRequest.getRequest({
      // method: "GET",
      // url: Connection + "/wenbo-" + API_PATHOBJ.api_model_school + "/lession/period/all-list"

      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/lession/period/all-list",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //教师所有
  getTeacherAll: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection + "/wenbo-" + API_PATHOBJ.api_model_course + "/teacher/all",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //新增课时信息
  insertCourseInfos: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      // url: Connection + "/wenbo-" + API_PATHOBJ.api_model_school + "/coursesession/save",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/lession/period/save",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //编辑课时信息
  updateCourseInfos: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        // "/coursesession/courseSubmit",
        // "/lession/period/courseSubmit",
        "/lession/period/submit",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //删除课时信息
  deleteCourseInfos: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        // "/coursesession/remove?ids=" +
        "/lession/period/remove?ids=" +
        params
    });
  },

  //获取通用的科目列表数据
  getCommonSubjectListInfos: function () {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/subject/listSubject"
    });
  },

  //新增科目信息
  insertSubjectInfo: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/subject/saveSubject",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //获取全校科目列表数据
  getSchoolSubjectListInfos: function (params) {
    return HttpRequest.getRequest({
      // method: "GET",
      // url: Connection + "/wenbo-" + API_PATHOBJ.api_model_school + "/subject/listSchoolSubject"

      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/subject/listSchoolSubject",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //年级科目列表
  getGradeSubjectListInfos: function (params) {
    return HttpRequest.getRequest({
      // method: "GET",
      // url: Connection + "/wenbo-" + API_PATHOBJ.api_model_school + "/subject/listSchoolGrade"

      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/subject/listSchoolGrade",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //删除年级关联的科目
  deleteGradeSubject: function (params) {
    return HttpRequest.getRequest({
      // method: "GET",
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        // "/subject/deleteGradeSubject?ids=" +
        "/subject/grade/remove?ids=" +
        params
    });
  },

  //年级科目添加
  insertGradeSubjectInfo: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/subject/saveGradeSubject",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //学级列表
  pageLearnGradeListInfos: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/studygrade/pageStudyGrade",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //学级页面获取学段列表-学校端使用
  getPeriodListInfo: function () {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/studygrade/listStudyPeriod"
    });
  },

  //学级页面获取学段列表-教育局端使用
  getPeriodListInfoEdu: function () {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/studygrade/listStudyPeriodEdu"
    });
  },

  //传学段id获取年级列表
  getGradeListBySegementId: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/grade/studyPeriodIdGradeList?ids=" +
        params
      // data: params
    });
  },

  //添加学级
  addStudyGrade: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/studygrade/saveStudyGrade",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //编辑学级
  updateStudyGrade: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/studygrade/update",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //删除学级
  deleteLearnGrade: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/studygrade/remove?ids=" +
        params,
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //获取学生信息-绑定孩子使用
  getStudentListForBind: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/guardian/studentList",
      data: params
    });
  },

  //添加家长信息
  addParentBaseInfo: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/guardian/saveGuardian",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //修改家长信息
  updateParentBaseInfo: function (params) {
    return HttpRequest.getRequest({
      method: "PUT",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/guardian/updateGuardian",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //删除家长信息
  deleteParentBaseInfo: function (datas) {
    return HttpRequest.getRequest({
      method: "DELETE",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/guardian/deleteGuardian?ids=" +
        datas
    });
  },

  //分页查询家长信息
  pageParentListInfo: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/guardian/pageGuardian",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //课程表-获取学级信息列表
  getLearnGradeListInfoForSchedule: function () {
    return HttpRequest.getRequest({
      method: "GET",
      // url: Connection + "/wenbo-" + API_PATHOBJ.api_model_school + "/course/scheduleGrade"
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/lession/scheduleGrade"
    });
  },

  //课程表-根据学级id 得到班级列表
  getClassInfosByLearnGrade: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        // "/course/scheduleClassList?studentGradeId=" +
        "/lession/scheduleClassList?studentGradeId=" +
        params,
      data: params
    });
  },

  //课程表-获取班级课程表
  getClassScheduleInfos: function (params) {
    return HttpRequest.getRequest({
      // method: "GET",
      // url:
      //   Connection +
      //   "/wenbo-" +
      //   API_PATHOBJ.api_model_school +
      //   "/lession/schedule",
      // // "/lession/schedule?classId=" +
      // // params
      // data: params

      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/lession/schedule",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  // getClassRelationTeacherInfos: function(params) {
  //   return HttpRequest.getRequest({
  //     method: "POST",
  //     url:
  //       Connection +
  //       "/wenbo-" +
  //       API_PATHOBJ.api_model_school +
  //       "/course/scheduleTeacherList",
  //     data: params,
  //     header: {
  //       "content-type": "application/json"
  //     }
  //   });
  // },

  //课程表-获取班级任教老师列表
  getClassRelationTeacherInfos: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/lession/scheduleTeacherList?classId=" +
        params
      // data: params
    });
  },

  //课程表-添加或移除当前课程表
  updateScheduleContentInfo: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      // url: Connection + "/wenbo-" + API_PATHOBJ.api_model_school + "/course/scheduleSubmit",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/lession/scheduleSubmit",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  // 阴性与阳性比例图形报表统计 学校端
  reportStatisticsSymptom: function (params) {
    return HttpRequest.getRequest({
      method: "get",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/epidemicsituation/reportStatisticsSymptom",
      data: params,
      header: {
        "content-type": "application/x-www-form-urlencoded"
      }
    });
  },

  // 发热比例图形报表统计 学校端
  reportStatisticsFever: function (params) {
    return HttpRequest.getRequest({
      method: "get",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/epidemicsituation/reportStatisticsFever",
      data: params,
      header: {
        "content-type": "application/x-www-form-urlencoded"
      }
    });
  },

  //获取当前租户年级列表
  gradeListInfos: function () {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/exam/gradeList"
    });
  },

  //年级id获取班级列表
  getClazzListByGradeId: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/exam/classList?gradeId=" +
        params,
      data: params
    });
  },

  //评级类型列表
  gradeTypeInfos: function () {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/exam/ratingTypesList"
    });
  },

  //年级id获取科目列表
  getSubjectListByGradeId: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/exam/sujectList?ids=" +
        params,
      data: params
    });
  },

  //创建成绩信息
  createExamInfomations: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/exam/saveExam",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },
  //分页获取成绩列表信息
  examList: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/exam/pageExam",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },
  //考试分页-我的任教
  pageExamTeach: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/exam/pageExamTeach",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },
  //考试分页-我的班级
  pageExamClass: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/exam/pageExamClass",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },
  //删除考试信息
  examDel: function (params) {
    return HttpRequest.getRequest({
      method: "DELETE",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/exam/examRemove?ids=" +
        params
    });
  },

  //考试评级详情类别
  getRatingCategoryListByExamId: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/exam/detailRatingCategory?examId=" +
        params,
      data: params
    });
  },

  //考试评级详情分数信息
  getdetailRatingScoreInfos: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/exam/detailRatingScore?examId=" +
        params,
      data: params
    });
  },

  //考试评级详情编辑
  editRateLevleInfos: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/exam/detailRatingUpdate",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //考试评级详情科目信息
  getRelateEnterScroeBase: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/exam/detailRating?examId=" +
        params,
      data: params
    });
  },

  //批改试卷学生列表
  pageCorrectPapersInfo: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/exam/correctPapers",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },
  //考试批卷详情
  getBatchDetailsInfo: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/exam/batchDetails?examId=" +
        params,
      data: params
    });
  },
  //获取批卷老师列表
  getBatchTeacherList: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/exam/batchTeacherList",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //导入学生成绩
  uploadImportTemplate: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/exam/importTemplate",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //发布考试成绩
  examResultPublish: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/exam/examResultPublish",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //取消公布考试成绩
  examResultPublishCancel: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/exam/examResultPublishCancel",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  // 市外当地图形报表统计 学校端
  reportStatisticsLocal: function (params) {
    return HttpRequest.getRequest({
      method: "get",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/epidemicsituation/reportStatisticsLocal",
      data: params,
      header: {
        "content-type": "application/x-www-form-urlencoded"
      }
    });
  },
  // 已上报未上报图形报表统计 学校端
  reportStatisticsReport: function (params) {
    return HttpRequest.getRequest({
      method: "get",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/epidemicsituation/reportStatisticsReport",
      data: params,
      header: {
        "content-type": "application/x-www-form-urlencoded"
      }
    });
  },

  // 十天数据柱状图形报表统计  学校端
  reportStatisticsColumnar: function (params) {
    return HttpRequest.getRequest({
      method: "get",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/epidemicsituation/reportStatisticsColumnar",
      data: params,
      header: {
        "content-type": "application/x-www-form-urlencoded"
      }
    });
  },
  //顶层分组列表
  getGroupListAll: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_resource +
        "/shanghai-gateway/group/listAll",
      data: params
    });
  },

  //文章添加
  addEssay: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_resource +
        "/shanghai-gateway/essay/add",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //文章分页列表
  essayPage: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_resource +
        "/shanghai-gateway/essay/page",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //文章删除
  deleteEssay: function (datas) {
    return HttpRequest.getRequest({
      method: "DELETE",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_resource +
        "/shanghai-gateway/essay/del?id=" +
        datas
    });
  },

  //文章修改
  updEssay: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_resource +
        "/shanghai-gateway/essay/upd",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //菜单分类-顶层分组列表
  listAll: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_resource +
        "/shanghai-gateway/group/listAll",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //自定义内容-纯文本分页
  pageText: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_resource +
        "/shanghai-gateway/pageText",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //自定义纯文本新增
  saveText: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_resource +
        "/shanghai-gateway/saveText",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //自定轮播图新增
  saveCarousel: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_resource +
        "/shanghai-gateway/saveCarousel",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //自定义链接新增
  saveLink: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_resource +
        "/shanghai-gateway/saveLink",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //自定义内容-修改
  updateLink: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_resource +
        "/shanghai-gateway/update",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //自定义内容-链接分页
  pageLink: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_resource +
        "/shanghai-gateway/pageLink",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //自定义内容-轮播图分页
  pageCarousel: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_resource +
        "/shanghai-gateway/pageCarousel",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //自定义内容 删除
  removeLink: function (datas, userId) {
    return HttpRequest.getRequest({
      method: "DELETE",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_resource +
        "/shanghai-gateway/remove?ids=" +
        datas +
        "&userId=" +
        userId
    });
  },

  //设置批卷老师
  setMarkingPaperTeacher: function (params1, params2) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/exam/batchTeacherSave?id=" +
        params1 +
        "&teacherId=" +
        params2
    });
  },

  //添加学生成绩
  commitExamResultSave: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/exam/examResultSave",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },
  //科目详情-年级统计-列表-图表
  getExamResultSubjectDetails: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/exam/examResultSubjectDetails",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  // getExamResultSubjectDetails: function (params1, params2, params3) {
  //     return HttpRequest.getRequest({
  //         method: "POST",
  //         url: Connection + "/wenbo-" +
  //             API_PATHOBJ.api_model_school +
  //             "/exam/examResultSubjectDetails?classId=" +
  //             params1 +
  //             "&examId=" +
  //             params2 +
  //             "&subjectId=" +
  //             params3
  //     });
  // },

  //考试详情
  pageExamDetailInfos: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/exam/examResultChart",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  // 获取学段列表 2.0版本
  lessonpreparationsemestersList: function () {
    return HttpRequest.getRequest({
      method: "get",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/lessonpreparation/semestersList",
      header: {
        "content-type": "application/x-www-form-urlencoded"
      }
    });
  },

  // 学段id获取年级列表 2.0版本
  lessonpreparationgradeList: function (params) {
    var data = QueryString.stringify(params);
    data = data == "" ? "" : "?" + data;
    return HttpRequest.getRequest({
      method: "get",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/lessonpreparation/gradeList" +
        data,
      header: {
        "content-type": "application/x-www-form-urlencoded"
      }
    });
  },

  // 年级id获取科目列表 2.0版本
  lessonpreparationsujectList: function (params) {
    var data = QueryString.stringify(params);
    data = data == "" ? "" : "?" + data;
    return HttpRequest.getRequest({
      method: "get",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/lessonpreparation/sujectList" +
        data,
      header: {
        "content-type": "application/x-www-form-urlencoded"
      }
    });
  },

  //加入-移除收藏 2.0版本
  lessonPreparationCollect: function (params) {
    var data = QueryString.stringify(params);
    data = data == "" ? "" : "?" + data;
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/lessonpreparation/lessonPreparationCollect" +
        data,
      header: {
        "content-type": "application/json"
      }
    });
  },

  lessonPreparationSave: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/lessonpreparation/lessonPreparationSave",
      header: {
        "content-type": "application/json"
      },
      data: params
    });
  },

  //监控地点列表
  monitorLocation: function () {
    return HttpRequest.getRequest({
      method: "get",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/camera/monitoringLocationsList"
    });
  },

  //监控列表
  monitorInfoList: function (params) {
    return HttpRequest.getRequest({
      method: "get",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/camera/monitoringList?code=" +
        params,
      data: params
    });
  },

  //监控预览
  monitorDetail: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/guardian/preview",
      header: {
        "content-type": "application/json"
      },
      data: params
    });
  },

  //获取学段信息列表-招聘信息 使用
  categoryChildList: function (params) {
    return HttpRequest.getRequest({
      method: "get",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_system +
        "/category/child-list",
      data: params
    });
  },

  //获取学段科目树
  getSubjectListByAcodemic: function (params) {
    return HttpRequest.getRequest({
      method: "get",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/studyperiodsubject/studyPeriodSubjectTree?id=" +
        params,
      data: params
    });
  },

  //教师招聘
  pageRecruitmentListInfo: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_recruitment +
        "/recruitment/recruitmentPage",
      header: {
        "content-type": "application/json"
      },
      data: params
    });
  },

  //报名人员列表
  pageTeacherRecruitmentPage: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_recruitment +
        "/entry/personnel/teacherRecruitmentPage",
      header: {
        "content-type": "application/json"
      },
      data: params
    });
  },

  //报名人员列表
  getTeacherInfoBySubject: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_recruitment +
        "/entry/personnel/toBeArrangedExamine",
      header: {
        "content-type": "application/json"
      },
      data: params
    });
  },

  //报名信息详情
  getRecruitmentDetails: function (params) {
    return HttpRequest.getRequest({
      method: "get",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_recruitment +
        "/entry/personnel/recruitmentDetails?id=" +
        params
    });
  },

  //编辑报名信息审核状态与备注
  updateRecruitmentInfo: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_recruitment +
        "/entry/personnel/teacherRecruitmentUpdate",
      header: {
        "content-type": "application/json"
      },
      data: params
    });
  },

  // 考试信息列表
  examInformationPage: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_recruitment +
        "/recruitmentexam/examInformationPage",
      header: {
        "content-type": "application/json"
      },
      data: params
    });
  },
  // 设置座位号
  setSeatNumber: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_recruitment +
        "/entry/personnel/settingSeatNumber",
      header: {
        "content-type": "application/json"
      },
      data: params
    });
  },

  //查询当前考场已经安排了考试的所有学生
  queryParticipateTeacherList: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_recruitment +
        "/recruitmentexam/queryArrangedExamination",
      header: {
        "content-type": "application/json"
      },
      data: params
    });
  },

  // 创建考试-教师招聘
  createTeacherExam: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_recruitment +
        "/recruitmentexam/createExam",
      header: {
        "content-type": "application/x-www-form-urlencoded"
      },
      data: params
    });
  },
  // 修改考试-教师招聘
  updateTeacherExam: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_recruitment +
        "/recruitmentexam/updateExamination",
      header: {
        "content-type": "application/x-www-form-urlencoded"
      },
      data: params
    });
  },
  //教师招聘
  pageRecruitmentListInfo: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_recruitment +
        "/recruitment/recruitmentPage",
      header: {
        "content-type": "application/json"
      },
      data: params
    });
  },

  //导出招聘考试报名信息
  exportRegistrationExcel: function (params) {
    return HttpRequest.getRequest({
      method: "get",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/person/exportRegistration",
      header: {
        "content-type": "application/json"
      },
      data: params
    });
  },

  //发布招聘信息
  postRecruitmentInfo: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_recruitment +
        "/recruitment/postJob",
      header: {
        "content-type": "application/json"
      },
      data: params
    });
  },

  //教师招聘列表（删除）
  deleteRecruitmentInfo: function (datas) {
    return HttpRequest.getRequest({
      method: "DELETE",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_recruitment +
        "/recruitment/recruitmentDelete?id=" +
        datas
    });
  },

  //招聘信息详情
  recruitmentInfoDetail: function (params) {
    return HttpRequest.getRequest({
      method: "get",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_recruitment +
        "/recruitment/detail?id=" +
        params
    });
  },

  //导出招聘考试报名信息
  exportRegistrationExcel: function (params) {
    return HttpRequest.getRequest({
      method: "get",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/person/exportRegistration",
      header: {
        "content-type": "application/json"
      },
      data: params
    });
  },

  spaceTreeList: function (params) {
    return HttpRequest.getRequest({
      method: "get",
      url:
        Connection + "/wenbo-" + API_PATHOBJ.api_model_school + "/space/list",
      header: {
        "content-type": "application/json"
      },
      data: params
    });
  },
  schoolspaceSave: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection + "/wenbo-" + API_PATHOBJ.api_model_school + "/space/submit",
      header: {
        "content-type": "application/json"
      },
      data: params
    });
  },

  // 获取学段
  categoryList: function (params) {
    return HttpRequest.getRequest({
      method: "get",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_system +
        "/category/child-list?parentId=1554354677609807873",
      header: {
        "content-type": "application/json"
      },
      data: params
    });
  },

  studyPeriodSubjectTree: function (params) {
    return HttpRequest.getRequest({
      method: "get",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/studyperiodsubject/studyPeriodSubjectTree",
      header: {
        "content-type": "application/json"
      },
      data: params
    });
  },

  candidateInformationPageList: function (params) {
    // candidateInformationPage: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_recruitment +
        "/entry/personnel/candidateInformationPage",
      header: {
        "content-type": "application/json"
      },
      data: params
    });
  },

  teacherRecruitmentUpdate: function (params) {
    // candidateInformationPage: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_recruitment +
        "/entry/personnel/teacherRecruitmentUpdate",
      header: {
        "content-type": "application/json"
      },
      data: params
    });
  },
  spaceremove: function (params) {
    return HttpRequest.getRequest({
      method: "delete",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/space/remove?ids=" +
        params.ids,
      header: {
        "content-type": "application/json"
      }
      // data: params
    });
  },

  recruitmentexamDetail: function (params) {
    return HttpRequest.getRequest({
      method: "get",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_recruitment +
        "/recruitmentexam/detail",
      header: {
        "content-type": "application/x-www-form-urlencoded"
      },
      data: params
    });
  },
  teacherRecruitmentDelete: function (params) {
    return HttpRequest.getRequest({
      method: "delete",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_recruitment +
        "/recruitmentexam/remove",
      header: {
        "content-type": "application/x-www-form-urlencoded"
      },
      data: params
    });
  },

  admissionTicketAcquisition: function (params) {
    return HttpRequest.getRequest({
      method: "get",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_recruitment +
        "/entry/personnel/admissionTicketAcquisition",
      header: {
        "content-type": "application/x-www-form-urlencoded"
      },
      data: params
    });
  },

  eduportalresourcessubmit: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/eduportalresources/submit",
      header: {
        "content-type": "application/x-www-form-urlencoded"
      },
      data: params
    });
  },

  eduportalresourcespage: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/eduportalresources/page",
      header: {
        "content-type": "application/x-www-form-urlencoded"
      },
      data: params
    });
  },

  eduportalresourcesremove: function (params) {
    return HttpRequest.getRequest({
      method: "delete",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/eduportalresources/remove?ids=" +
        params.ids,
      header: {
        "content-type": "application/x-www-form-urlencoded"
      },
      data: params
    });
  },
  eduportalteachersubmit: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/eduportalteacher/submit",
      header: {
        "content-type": "application/x-www-form-urlencoded"
      },
      data: params
    });
  },
  schoolList: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/school/schoolList",
      header: {
        "content-type": "application/x-www-form-urlencoded"
      },
      data: params
    });
  },
  gradeListEdu: function (params) {
    return HttpRequest.getRequest({
      method: "get",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/epidemicsituation/gradeListEdu",
      header: {
        "content-type": "application/x-www-form-urlencoded"
      },
      data: params
    });
  },
  classListEdu: function (params) {
    return HttpRequest.getRequest({
      method: "get",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/epidemicsituation/classListEdu",
      header: {
        "content-type": "application/x-www-form-urlencoded"
      },
      data: params
    });
  },
  eduportalteacherpage: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/eduportalteacher/page",
      header: {
        "content-type": "application/x-www-form-urlencoded"
      },
      data: params
    });
  },
  eduportalteacherremove: function (params) {
    return HttpRequest.getRequest({
      method: "delete",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/eduportalteacher/remove?ids=" +
        params.ids,
      header: {
        "content-type": "application/x-www-form-urlencoded"
      },
      data: params
    });
  },

  //专题课程-新增或修改
  addSpecialResource: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/etscourse/submit",
      header: {
        "content-type": "application/x-www-form-urlencoded"
      },
      data: params
    });
  },

  //专题课程-分页
  pageSpecialResource: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/etscourse/page",
      header: {
        "content-type": "application/x-www-form-urlencoded"
      },
      data: params
    });
  },

  specialResourceDetail: function (params) {
    return HttpRequest.getRequest({
      method: "get",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/etscourse/detail",
      header: {
        "content-type": "application/x-www-form-urlencoded"
      },
      data: params
    });
  },

  //专题-小节目录分页
  pageSectionContents: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/etssection/page",
      header: {
        "content-type": "application/x-www-form-urlencoded"
      },
      data: params
    });
  },

  //专题-小节-新增或修改
  addSectionContents: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/etssection/submit",
      header: {
        "content-type": "application/x-www-form-urlencoded"
      },
      data: params
    });
  },

  getSectionDetail: function (params) {
    return HttpRequest.getRequest({
      method: "get",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/etssection/detail",
      header: {
        "content-type": "application/x-www-form-urlencoded"
      },
      data: params
    });
  },

  //上传指定视频的学习进度
  addSectionVedioProcess: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/etssectionstudy/submit",
      header: {
        "content-type": "application/x-www-form-urlencoded"
      },
      data: params
    });
  },

  //加入-移除收藏 2.0版本
  addRemoveFavorites: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/etssection/sectionCollect",
      header: {
        "content-type": "application/x-www-form-urlencoded"
      },
      data: params
    });
  },

  //加入-移除收藏  -  专题
  addRemoveCourseResourceFavorites: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/etscourse/courseCollect",
      header: {
        "content-type": "application/x-www-form-urlencoded"
      },
      data: params
    });
  },

  //小节观看人数排名  -  专题
  resourceRankInfoList: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/etssectionstudy/sectionStudyPage",
      header: {
        "content-type": "application/x-www-form-urlencoded"
      },
      data: params
    });
  },

  //新增或修改 -加入学习  -  专题
  specialResourceInfoAdding: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/etscoursestudy/submit",
      header: {
        "content-type": "application/x-www-form-urlencoded"
      },
      data: params
    });
  },

  //逻辑删除
  deleteSectionReourceInfo: function (datas) {
    return HttpRequest.getRequest({
      method: "DELETE",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/etssection/remove?ids=" +
        datas
    });
  },

  //逻辑删除 - 专题课程
  deleteEtscourseReourceInfo: function (datas) {
    return HttpRequest.getRequest({
      method: "DELETE",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/etscourse/remove?ids=" +
        datas
    });
  },

  //优秀教师老师信息搜索
  eduportalteacherSchoolTeacher: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/eduportalteacher/schoolTeacher",
      header: {
        "content-type": "application/x-www-form-urlencoded"
      },
      data: params
    });
  },

  //考试的科目班级信息
  examPagerCorrectSubjectClassList: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/examPagerCorrect/subjectClassList",
      header: {
        "content-type": "application/x-www-form-urlencoded"
      },
      data: params
    });
  },

  //考试成绩录入权限老师分页
  examPagerCorrectPage: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/examPagerCorrect/examPagerCorrectPage",
      header: {
        "content-type": "application/x-www-form-urlencoded"
      },
      data: params
    });
  },

  //设置批卷老师
  examPagerCorrectBatchTeacher: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/examPagerCorrect/batchTeacher",
      header: {
        "content-type": "application/x-www-form-urlencoded"
      },
      data: params
    });
  },

  //编辑批卷老师
  examPagerCorrectBatchTeacherUpdate: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/examPagerCorrect/batchTeacherUpdate",
      header: {
        "content-type": "application/x-www-form-urlencoded"
      },
      data: params
    });
  },

  //删除考试成绩录入老师
  examPagerCorrectRemove: function (id) {
    return HttpRequest.getRequest({
      method: "DELETE",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/examPagerCorrect/examPagerCorrectRemove?ids=" +
        id
    });
  },

  //一键修改学生成绩
  examResultUpdate: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/exam/examResultUpdate",
      data: params
    });
  },

  //删除考试成绩记录
  examStudentRemove: function (examId, studentId) {
    return HttpRequest.getRequest({
      method: "DELETE",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/exam/examStudentRemove?examId=" +
        examId +
        "&studentId=" +
        studentId
    });
  },

  //编辑考试
  examUpdateExam: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/exam/updateExam",
      data: params
    });
  },

  //成绩图表
  examResultSubject: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/exam/examResultSubject",
      data: params
    });
  },

  //新增或修改一级标签
  addLabelOne: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/label/labelOneSave",
      data: params
    });
  },

  //标签信息列表
  pageLabelListInfos: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/label/labelList",
      data: params
    });
  },

  //新增或修改二级标签
  addLabelTwo: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/label/labelTwoSave",
      data: params
    });
  },

  //批量(或单个)删除标签信息-综合素质评价
  deleteLabelInfos: function (datas) {
    return HttpRequest.getRequest({
      method: "DELETE",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/label/labelDelete?ids=" +
        datas
    });
  },

  //根据年级班级信息查询学生评价列表-综合素质评价
  queryStudentEvaluateInfos: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/labelScore/labelScorePage",
      data: params
    });
  },

  //根据年级班级信息查询班级全部学生-综合素质评价
  queryStudentEvaluateInfos2: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/labelScore/labelScoreList",
      data: params
    });
  },

  //学生评价历史分页-综合素质评价
  pageLabelScoreHistory: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/labelScore/labelScoreHistoryPage",
      data: params
    });
  },

  //学生评价详情-综合素质评价
  studentLabelDetail: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/labelScore/labelScoreDetails",
      data: params
    });
  },

  //新增学生评价信息-综合素质评价
  addStudentEvalution: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/labelScore/labelScoreSave",
      data: params
    });
  },

  //班级id获取学生列表-综合素质评价
  queryStudentInfoByClazzId: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/student/studentList",
      data: params
    });
  },

  //批量新增学生评价-综合素质评价
  addStudentEvaluate: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/labelScore/labelScoreSaveBatch",
      data: params
    });
  },

  //考试指标分页
  examinationPage: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/assessment/type/examinationPage",
      data: params
    });
  },

  //考试指标新增或修改
  examinationSubmit: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/assessment/type/examinationSubmit",
      data: params
    });
  },

  //删除考试成绩记录
  examinationRemove: function (id) {
    return HttpRequest.getRequest({
      method: "DELETE",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/assessment/type/examinationRemove?ids=" +
        id
    });
  },

  //考试指标下拉框
  examinationList: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/assessment/type/examinationList",
      data: params
    });
  },

  //考试指标科目对应分数信息
  pointingHeaderScore: function (id) {
    return HttpRequest.getRequest({
      method: "get",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/exam/pointingHeaderScore?examId=" +
        id
    });
  },

  //考试指标头信息
  pointingHeader: function (id) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/exam/pointingHeader?examId=" +
        id
    });
  },

  //下载成绩录入模板
  examDownloadTemplate: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/exam/downloadTemplate",
      data: params
    });
  },

  //根据考试id 科目id 获取最高分
  highestScore: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/exam/highestScore",
      data: params
    });
  },

  //日程列表
  scheduleList: function () {
    return HttpRequest.getRequest({
      method: "get",
      url:
        Connection + "/wenbo-" + API_PATHOBJ.api_model_school + "/schedule/list"
    });
  },

  //日程新增（弃用）
  scheduleSave: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/schedule/save",
      data: params
    });
  },

  //日程修改
  scheduleUpdate: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/schedule/update",
      data: params
    });
  },

  //日程删除
  scheduleRemove: function (id) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/schedule/remove?ids=" +
        id
    });
  },

  //公共课程设置-列表
  publicList: function (id) {
    return HttpRequest.getRequest({
      method: "get",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/lesson/public/list/" +
        id
    });
  },

  //公共课程设置-新增
  publicSave: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/lesson/public/save",
      data: params
    });
  },

  //公共课程设置-删除
  publicRemove: function (semesterId, id) {
    return HttpRequest.getRequest({
      method: "DELETE",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/lesson/public/remove?semesterId=" +
        semesterId +
        "&id=" +
        id
    });
  },

  //授课计划-列表
  lessionPlanList: function (semesterId, params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/lesson/plan/list/" +
        semesterId,
      data: params
    });
  },

  //授课计划-新增
  lessionPlanSave: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/lesson/plan/save",
      data: params
    });
  },

  //授课计划-修改
  lessionPlanUpdate: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/lesson/plan/update",
      data: params
    });
  },

  //授课计划-删除
  lessionPlanRemove: function (id) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/lesson/plan/remove?ids=" +
        id
    });
  },

  //获取场地禁排列表
  getCampusCourseList: function (semesterId) {
    return HttpRequest.getRequest({
      method: "get",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/lesson/condition/space/list/" +
        semesterId
    });
  },

  //场地禁排添加(批量)
  createCampusCourses: function (semesterId, params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/lesson/condition/space/batchSave/" +
        semesterId,
      data: params
    });
  },

  //场地禁排删除(批量)
  deleteCampusCourses: function (semesterId, params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/lesson/condition/space/batchRemove/" +
        semesterId,
      data: params
    });
  },

  //获取科目禁排列表
  getConditionSubjectList: function (semesterId, gradeId) {
    return HttpRequest.getRequest({
      method: "get",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/lesson/condition/subject/list/" +
        semesterId +
        "?gradeId=" +
        gradeId
    });
  },

  //科目禁排添加(批量)
  conditionSubjectBatchSave: function (semesterId, params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/lesson/condition/subject/batchSave/" +
        semesterId,
      data: params
    });
  },

  //科目禁排删除(批量)
  conditionSubjectBatchRemove: function (semesterId, params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/lesson/condition/subject/batchRemove/" +
        semesterId,
      data: params
    });
  },

  //查询排课设置
  lessonConditionList: function (semesterId, params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/lesson/condition/list/" +
        semesterId,
      data: params
    });
  },

  //添加排课设置
  conditionBatchSave: function (semesterId, params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/lesson/condition/batchSave/" +
        semesterId,
      data: params
    });
  },

  //删除排课设置
  conditionRemove: function (semesterId, id) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/lesson/condition/remove?ids=" +
        id
    });
  },

  //合班列表
  getJoinClassList: function (semesterId) {
    return HttpRequest.getRequest({
      method: "get",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/join/class/list"
    });
  },

  //添加合班
  joinClassSave: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/join/class/save",
      data: params
    });
  },

  //修改合班
  joinClassUpdate: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/join/class/update",
      data: params
    });
  },

  //删除合班
  joinClassRemove: function (id) {
    return HttpRequest.getRequest({
      method: "DELETE",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/join/class/remove?id=" +
        id
    });
  },

  //学期下拉框
  semesterInfoList: function () {
    return HttpRequest.getRequest({
      method: "get",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/semester/semesterList"
    });
  },

  //根据日期和课时查询 具体的 科目信息
  detailSubjectInfoByDateAndLesson: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/lession/lessionSuject",
      data: params
    });
  },

  //学段id 获取已激活学期信息
  querySemesterInfoBystudyPeriodId: function (params) {
    return HttpRequest.getRequest({
      method: "get",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/labelScore/labelScoreActivated?studyPeriodId=" +
        params
    });
  },

  scroeInfosDownLoad: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/exam/downloadTemplate",
      data: params
    });
  },

  scroeInfosDownLoad2: function (params) {
    var data = QueryString.stringify(params);
    return HttpRequest.getRequest({
      method: "get",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/exam/downloadTemplate1?" +
        data
    });
  },

  //调课申请，查询当前老师 任教班级
  queryCurrentTeacherRelateClazz: function () {
    return HttpRequest.getRequest({
      method: "get",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/exchangecourses/exchangeClass"
    });
  },

  //调课申请，查询当前老师 任教科目
  queryCurrentTeacherRelateSubject: function () {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/exchangecourses/exchangeClassTeacherSuject"
    });
  },

  //调课申请，查询 该班级所有的科目信息
  queryCurrentClazzAllSubjectInfos: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/exchangecourses/exchangeClassSujectAll",
      data: params
    });
  },

  //调课申请，查询该老师 该班级 的任教的 科目信息
  queryCurrentTeacherClazzSubjectInfos: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/exchangecourses/exchangeClassSuject",
      data: params
    });
  },

  //调课申请，根据班级-科目-日期 信息 查询课堂信息 当前老师
  queryLessoninfoCurrentTeacherByClazzSubjectDate: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/exchangecourses/exchangeLesson",
      data: params
    });
  },

  //调课申请 - 根据班级-科目-日期 信息 查询课堂信息
  queryLessoninfoByClazzSubjectDate: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/exchangecourses/exchangeLessonChoose",
      data: params
    });
  },

  //调课申请 - 审批人选择 学校端角色（临时） 具体需要 产品最终确定
  queryApprovalList: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/exchangecourses/exchangeApproval",
      data: params
    });
  },

  //调课申请 - 根据科目查询班级(同年级)
  queryClazzBySubject: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/exchangecourses/exchangeSujectGrade",
      data: params
    });
  },

  //调课申请 - 根据科目选择班级信息（当前老师）
  queryCurrentTeacherRelateClazzBySubject: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/exchangecourses/exchangeSujectClass",
      data: params
    });
  },

  //调课申请 - 创建
  createExchangeCourseInfo: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/exchangecourses/exchangeCoursesSubmit",
      data: params
    });
  },
  //调课申请 - 分页查询
  pageExchangeCourseInfoList: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/exchangecourses/exchangeCoursesPage",
      data: params
    });
  },

  //调课申请 列表 - 删除操作
  deleteExchangeCourseInfo: function (datas) {
    return HttpRequest.getRequest({
      method: "DELETE",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/exchangecourses/remove?ids=" +
        datas
    });
  },

  //调课申请  撤回
  recallExchangeCourseInfo: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/exchangecourses/exchangeWithdraw",
      data: params
    });
  },

  //调课申请  重新申请
  reapplayExchangeCourseInfo: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/exchangecourses/exchangeAgain",
      data: params
    });
  },

  //调课审批-待审批列表分页
  pageApprovalListInfo: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/approvalrecord/approvalRecordPage",
      data: params
    });
  },

  //调课审批-审批记录分页
  approvalledListInfo: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/approvalrecord/approvalRecordRecord",
      data: params
    });
  },

  //调课审批-同意/拒绝
  updateApprovalStatu: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/approvalrecord/approvalRecordUpdate",
      data: params
    });
  },

  //调课审批-列表 删除
  deleteApprovalledInfo: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/approvalrecord/remove?ids=" +
        params
    });
  },

  //学年
  querySchoolYearListInfos: function () {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/schoolyear/schoolYearList"
    });
  },

  //行程-老师列表
  scheduleTeacherListInfos: function () {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/schedule/teacherList"
    });
  },

  //形成-添加/修改
  addScheduleInfo: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/schedule/scheduleSaveOrUpdate",
      data: params
    });
  },

  //我的日程列表
  pageScheduleListInfos: function () {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/schedule/scheduleList"
    });
  },

  //日程-取消行程
  cancleScheduleInfo: function (datas) {
    return HttpRequest.getRequest({
      method: "DELETE",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/schedule/scheduleCancel?scheduleId=" +
        datas
    });
  },

  //日程邀请通知 当前用户被邀请
  scheduleInvitationNotice: function () {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/schedule/scheduleInviteNotice"
    });
  },

  //日程邀请 - 同意
  scheduleInvitationAccept: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/schedule/scheduleAccept",
      data: params
    });
  },

  //日程邀请 - 拒绝
  scheduleInvitationRefuse: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/schedule/scheduleReject",
      data: params
    });
  },

  //校本资源学段科目树
  periodSubjectTreeList: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/resource/getAllSchoolResourceSubjectTree",
      data: params
    });
  },

  // 章节
  schoolResourceChapter: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/resource/getAllSchoolResourceChapter",
      data: params
    });
  },

  //校本资源-删除 2.0版本
  schoolResourceDelete: function (params) {
    return HttpRequest.getRequest({
      method: "DELETE",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/resource/remove?ids=" +
        params
    });
  },

  testChatGpt: function (params) {
    return HttpRequest.getRequest({
      method: "post",
      url:
        Connection + "/wenbo-" + API_PATHOBJ.api_model_school + "/Ai/chatGpt",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  scheduleDetailInfo: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/schedule/scheduleDetails",
      data: params
    });
  },

  teacherSelftInfo: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/teacher/detailHome",
      data: params
    });
  },

  //标签首页统计
  labelInfoList: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/labelScore/labelScoreStatistics",
      data: params
    });
  },

  //成绩图表-雷达图
  examInfoList: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/exam/examResultSubject",
      data: params
    });
  },

  // 个人信息 - 学校端使用
  schoolClientSelfDetailInfo: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/eduportalresources/dataStatistics",
      data: params
    });
  },

  // 班级id获取考试科目列表
  subjectListInfoByClazzId: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/exam/sujectClassList?id=" +
        params
    });
  },

  //集体备课-教师列表
  teacherInfoList: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/lessonpreparation/teacherPage",
      data: params
    });
  },

  //集体备课-发起集备
  commitPrepareInfos: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/lessonpreparation/lessonPreparationSave",
      data: params
    });
  },

  //集体备课-分页查询
  pagePrepareListInfos: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/lessonpreparation/lessonPreparationPage",
      data: params
    });
  },

  //集体备课-被邀请人列表
  invitedPersonListInfos: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/lessonpreparation/lessonPreparationInvite",
      data: params
    });
  },

  //集体备课-首页统计 饼图
  preparationStatistics: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/lessonpreparation/lessonPreparationStatistics",
      data: params
    });
  },

  //集体备课-集备历史列表
  pagePrepareHistoryListInfos: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/lessonpreparation/lessonPreparationHistoryPage",
      data: params
    });
  },

  //集体备课-详情
  prepareDetailInfos: function (params) {
    return HttpRequest.getRequest({
      method: "get",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/lessonpreparation/lessonPreparationDetails?id=" +
        params
    });
  },

  //集体备课-通知-同意与拒绝
  noticePrepareOperate: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/lessonpreparation/lessonPreparationDecide",
      data: params
    });
  },

  //集体备课-详情-更改状态
  updateStatuInfo: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/lessonpreparation/lessonPreparationState",
      data: params
    });
  },

  //集体备课-模板分页查询
  prepareTemplateListInfo1: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/lessonPreparationTemplate/templatePage",
      data: params
    });
  },

  //集体备课-模板列表
  prepareTemplateListInfo2: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/lessonPreparationTemplate/templateList",
      data: params
    });
  },

  //集体备课-完成集备
  prepareInfoFinished: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/lessonpreparation/lessonPreparationComplete",
      data: params
    });
  },

  // 集体备课-在线编辑
  prepareOnlineEdit: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url: "/office" + "/only/edit",
      data: params
    });
  },

  // 集体备课-获取知识点
  getKnowledgeListInfos: function (params) {
    return HttpRequest.getRequest({
      method: "get",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/resource/getAllSchoolResourceKnowledge",
      data: params
    });
  },

  //集体备课-删除
  prepareInviteDelete: function (params) {
    return HttpRequest.getRequest({
      method: "DELETE",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/lessonpreparation/lessonPreparationInviteRemove?ids=" +
        params
    });
  },

  // 社交圈-发布
  socialCirclePublic: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/dynamic/submitTrends",
      data: params
    });
  },

  // 社交圈-班级列表
  clazzListInfos: function () {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/dynamic/teachingClass"
    });
  },

  // 社交圈-列表信息
  pageSchoolCircleListInfos: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/dynamic/schoolTrendsPage",
      data: params
    });
  },

  // 社交圈-班级圈
  pageClazzCircleListInfos: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/dynamic/classTrendsPage",
      data: params
    });
  },

  // 社交圈-一级分页
  pageCommitFirstListInfo: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/dynamic/dynamicCommentPage",
      data: params
    });
  },

  // 社交圈-评论
  addCommitResultInfos: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/dynamic/submitComment",
      data: params
    });
  },

  // 社交圈-对1级或2级评论进行 点赞或取消点赞
  thumbsUpOrDown: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/dynamic/commentFabulous",
      data: params
    });
  },
  // 社交圈-  点赞或取消点赞
  thumbsContentUpOrDown: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/dynamic/dynamicFabulous",
      data: params
    });
  },

  // 社交圈-二级评论列表
  secondCommitListInfo: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/dynamic/dynamicCommentSecondPage",
      data: params
    });
  },

  // 社交圈-对评论信息  进行评论
  replyCommitInfo: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/dynamic/replyComment",
      data: params
    });
  },

  // 社交圈-班级圈  任教班级列表
  teachClazzListInfos: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/dynamic/teachingClass",
      data: params
    });
  },

  // 社交圈-我的动态
  dynamicOfMine: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/dynamic/myTrendsPage",
      data: params
    });
  },

  // 社交圈-转发
  transmissionInfo: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/dynamic/submitForward",
      data: params
    });
  },

  // 社交圈-主页信息
  teacherHomePageInfo: function (params) {
    return HttpRequest.getRequest({
      method: "get",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/dynamic/myHomepage",
      data: params
    });
  },

  //社交圈-删除动态
  socialCircleItemRemove: function (datas) {
    return HttpRequest.getRequest({
      method: "DELETE",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/dynamic/remove?id=" +
        datas
    });
  },

  //社交圈-删除评论
  socialCircleCommitRemove: function (datas) {
    return HttpRequest.getRequest({
      method: "DELETE",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/dynamic/commentRemove?id=" +
        datas
    });
  },

  // 社交圈-动态详情
  socialCircleDetailInfo: function (params) {
    return HttpRequest.getRequest({
      method: "get",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/dynamic/detail?id=" +
        params
    });
  },

  // test1111111: function(params) {
  //   return HttpRequest.getRequest({
  //     method: "POST",
  //     url:
  //       Connection +
  //       "/wenbo-" +
  //       API_PATHOBJ.api_model_school +
  //       "/thirdParty/getTenantRel",
  //     data: params
  //   });
  // },

  // 成绩-启用指标
  startUsingTargetType: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/assessment/type/examinationUpdate",
      data: params
    });
  },

  // 教师招聘 - 学段学科 树状结构
  recruitPeriodSubject: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/recruitmentitem/recruitmentItemList",
      data: params
    });
  },

  // 请求接口-增加下载量
  downLoadResTip: function (params) {
    return HttpRequest.getRequest({
      method: "get",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/resource/resourceDownload?ids=" +
        params
    });
  },

  lessonPreparationRemove: function (params) {
    return HttpRequest.getRequest({
      method: "delete",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/lessonpreparation/lessonPreparationRemove?ids=" +
        params,
      header: {
        "content-type": "application/x-www-form-urlencoded"
      },
      data: params
    });
  },

  attendanceRecordLog: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_attendance +
        "/attendance-statistics/recordLog",
      data: params
    });
  },

  attendanceGroupList: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_attendance +
        "/attendance-group/group-list",
      data: params
    });
  },

  queryDeviceListInfo: function () {
    return HttpRequest.getRequest({
      method: "get",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_attendance +
        "/attendance-group/attendanceDevice"
    });
  },

  addAttendanceRuleInfo: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_attendance +
        "/attendance-rule/add",
      data: params
    });
  },

  addAttendanceRuleList: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_attendance +
        "/attendance-rule/list",
      data: params
    });
  },

  addAttendanceRuleGroupList: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_attendance +
        "/attendance-rule/ruleGroupList",
      data: params
    });
  },

  deleteAttendanceRuleInfo: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_attendance +
        "/attendance-rule/delete",
      data: params
    });
  },

  addAttendanceGroupInfo: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_attendance +
        "/attendance-group/addAttendanceGroup",
      data: params
    });
  },

  deleteAttendanceGroupInfo: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_attendance +
        "/attendance-group/delete",
      data: params
    });
  },

  downloadAttendanceTemplate: function () {
    return HttpRequest2.getRequest({
      method: "get",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_attendance +
        "/attendance-group/downLoadAttendancePersonExcelTemplate"
    });
  },

  importAttendancePersonInfos: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_attendance +
        "/attendance-group/importAttendancePerson",
      data: params,
      header: {
        "content-type": "multipart/form-data"
      }
    });
  },

  attendanceGroupPersonList: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_attendance +
        "/attendance-group-person/list",
      data: params,
      header: {
        "content-type": "multipart/form-data"
      }
    });
  },

  deleteAttendanceGroupPerson: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_attendance +
        "/attendance-group-person/delete",
      data: params,
      header: {
        "content-type": "multipart/form-data"
      }
    });
  },

  updateAttendanceGroupInfo: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_attendance +
        "/attendance-group/update",
      data: params,
      header: {
        "content-type": "multipart/form-data"
      }
    });
  },

  updateAttendanceGroupRule: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_attendance +
        "/attendance-rule/update",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  attendanceRecordList: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_attendance +
        "/attendance-record/attendanceRecord",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  abnormalAttendanceRecordList: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_attendance +
        "/attendance-record/abnormalAttendanceRecord",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  monthlyStatisticalReportList: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_attendance +
        "/attendance-statistics/monthlyStatisticalReport",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  attendanceInfoAddRemark: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_attendance +
        "/attendance-statistics/addRemark",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  pageOperateList: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/operlog/page",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  pageOperateList: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/operlog/page",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  pageOperateAdminList: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/operlog/pageAdmin",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  //考勤模块---月统计报表
  downloadMonthlyStatisticalReport: function (params) {
    return HttpRequest2.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_attendance +
        "/attendance-statistics/exportMonthlyStatisticalReport",
      data: params,
      header: {
        "content-type": "application/x-www-form-urlencoded"
      }
    });
  },

  //考勤模块---导出考勤异常报表
  downloadAbnormalClockInRecord: function (params) {
    return HttpRequest2.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_attendance +
        "/attendance-record/exportAbnormalClockInRecord",
      data: params,
      header: {
        "content-type": "application/x-www-form-urlencoded"
      }
    });
  },

  //考勤模块---导出考勤报表
  downloadAttendanceRecordReport: function (params) {
    return HttpRequest2.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_attendance +
        "/attendance-record/exportAttendanceRecordReport",
      data: params,
      header: {
        "content-type": "application/x-www-form-urlencoded"
      }
    });
  },

  //导出指定考场已安排考试的考生信息
  downloadExportEntryPerson: function (params) {
    return HttpRequest2.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/entry/personnel/exportEntryPerson",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  resetPasswdInfo: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_platform +
        "/user/reset/passwordPc",
      data: params,
      header: {
        "content-type": "application/x-www-form-urlencoded"
      }
    });
  },

  pageSchoolUserList: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_user +
        "/userPage",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  bindSchoolInfo: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_user +
        "/teacherBinding",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  unbindSchoolInfo: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_user +
        "/teacherDeleteBinding",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  unbindSchoolInfo2: function (params) {
    return HttpRequest.getRequest({
      method: "POST",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/teacher/teacherDeleteBinding",
      data: params,
      header: {
        "content-type": "application/json"
      }
    });
  },

  changeRecruitmentStatu: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/recruitment/setStatus",
      data: params,
      header: {
        "content-type": "application/x-www-form-urlencoded"
      }
    });
  },

  changeDownLoadStatu: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/recruitment/setDownloadStatus",
      data: params,
      header: {
        "content-type": "application/x-www-form-urlencoded"
      }
    });
  },

  examStudentInfos: function (params) {
    return HttpRequest.getRequest({
      method: "GET",
      url:
        Connection +
        "/wenbo-" +
        API_PATHOBJ.api_model_school +
        "/entry/personnel/queryCandidateBriefInformation",
      data: params,
      header: {
        "content-type": "application/x-www-form-urlencoded"
      }
    });
  },

};
export { http };



// WEBPACK FOOTER //
// ./src/request/api.js